import EstablishmentUserApi from '../api/establishment/EstablishmentUserApi';
import * as types from './actionTypes';
import { startAjaxCall, startAjaxCallError } from './ajaxStatusActions';
import * as errorConstants from '../constants/errorMessages';

export function loadAllEstablishmentUsersSuccess(establishmentUsers) {
    return { type: types.LOAD_ESTABLISHMENT_USERS_SUCCESS, establishmentUsers };
}

export function createEstablishmentUserSuccessful(establishmentUsers) {
    return { type: types.CREATE_ESTABLISHMENT_USER_SUCCESS, establishmentUsers };
}

export function removeEstablishmentUsersSuccessful(establishmentUsers) {
    return { type: types.REMOVE_ESTABLISHMENT_USERS_SUCCESS, establishmentUsers };
}

export function saveEstablishmentUsersSuccessful(establishmentUsers) {
    return { type: types.SAVE_ESTABLISHMENT_USERS_SUCCESS, establishmentUsers };
}

export function editEstablishmentUser(establishmentusers) {
    return { type: types.EDIT_ESTABLISHMENT_USER_SUCCESS, establishmentusers };
}

export function validateEstablishmentUser(establishmentUserEmail) {
    return function () {
        return EstablishmentUserApi.validateEstablishmentUser(establishmentUserEmail);
    };
}

export function loadAllEstablishmentUsers(establishmentId) {
    return function (dispatch) {
        dispatch(startAjaxCall());
        return EstablishmentUserApi.getEstablishmentUsersApi(establishmentId)
            .then(response => {
                if (response.success) {
                    dispatch(loadAllEstablishmentUsersSuccess(response.results));
                } else {
                    dispatch(startAjaxCallError(response));
                }
            }).catch(error => {
                dispatch(startAjaxCallError(error));
                throw error;
            });
    };
}

export function saveEstablishmentUser(establishmentUserObj) {
        return function (dispatch) {
            return EstablishmentUserApi.saveEstablishmentUsers(establishmentUserObj)
                .then(response => {
                    if (response.success && response.results && response.results.establishment_users[0]) {
                        dispatch(saveEstablishmentUsersSuccessful(response.results));
                        dispatch(loadAllEstablishmentUsers(response.results.establishment_users[0].establishment_id));
                        return response.success;
                    } else {
                        let error = errorConstants.ERROR_SERVER;
                        if (response.error) {
                            error = errorConstants.ERROR_SERVER;
                        } else {
                            error = response.error;
                        }
                        dispatch(startAjaxCallError(error));
                        throw error;
                    }
                }).catch(error => {
                    dispatch(startAjaxCallError(error));
                    throw error;
                });
        };
}


/** WEBPACK FOOTER **
 ** ./src/actions/establishmentUserActions.js
 **/